import { AxiosRequestConfig, AxiosResponse } from "axios";
import { extractError } from "./misc";
import { getAccessToken } from "./tokens";

export function requestAccessTokenInterceptor(config: AxiosRequestConfig) {
  const token = getAccessToken();
  if (config.headers) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}

export function responseStatusInterceptor(response: AxiosResponse) {
  if (response.status < 200 || response.status >= 300) {
    throw new Error(extractError(response.data));
  }
  return response;
}
